import { Trans, t } from '@lingui/macro';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Kpi from 'components/customer/campaign/monitor/chart/Kpi';
import { NormalSpacePaddedSegment } from 'components/ui/Segment';
import { TitleSpan } from 'components/ui/dashboard/DashboardElement';
import HelpcrunchHelpTooltip from 'components/ui/navigation/HelpcrunchHelpTooltip';

import commonPropTypes from 'utils/commonPropTypes';
import { numberFormatter, onePrecisionFloatFormatter } from 'utils/formatter';
import capitalizedTranslation from 'utils/i18n';

import * as svars from 'assets/style/variables';

export const formatKpiValue = (value, formatter, isAbsolute) => {
  let formatted = value;
  let suffix = '';
  let sign = '';
  if (typeof formatted === 'number') {
    if (!isAbsolute) {
      formatted *= 100;
      suffix = '%';
    }
    // Remove sign when rounded value is 0.00
    formatted = Math.abs(formatted) < 0.005 ? Math.abs(formatted) : formatted;
    // The threshold is > 0 since we round the value to a 2-precision float and
    // want to avoid -0.03 to be formatted as -0.0
    sign = (formatted > 0.005 && '+') || '';
  }
  return `${sign}${formatter(formatted)}${suffix}`;
};

const KpiContainer = styled(NormalSpacePaddedSegment)`
  &&&&& {
    display: flex;
    flex-direction: column;
    margin: 0 ${svars.spaceSmaller};
    min-width: 200px;
  }
`;

export function DashboardKpi({
  headerTextId,
  value,
  increase,
  color,
  formatter,
  increaseFormatter,
  description,
  articleId,
  // kpiValueTestId,
  loading,
}) {
  return (
    <KpiContainer>
      <span style={{ width: '100%' }}>
        <TitleSpan>
          <span>
            <Trans render={capitalizedTranslation} id={headerTextId} />
            <HelpcrunchHelpTooltip
              smallTooltip
              articleId={articleId}
              style={{
                marginTop: `${svars.spaceSmaller}`,
              }}
              position="bottom right"
              helpText={
                <div>
                  <p>{description}</p>
                  <p>
                    <i style={{ textDecoration: 'underline' }}>
                      <Trans id="dashboard-kpi.30-days-variation" /> :
                    </i>{' '}
                    <Trans id="dashboard-kpi.30-days-variation-description" />
                  </p>
                </div>
              }
            />
          </span>
        </TitleSpan>
      </span>
      <Kpi
        data={{
          value,
          increase,
        }}
        meta={{
          color,
          formatter,
          increaseFormatter,
          emptyDataMessage: t({ id: 'no-data' }),
        }}
        loading={loading}
        chartId="volume"
      />
    </KpiContainer>
  );
}

DashboardKpi.propTypes = {
  headerTextId: commonPropTypes.i18nText.isRequired,
  value: PropTypes.number,
  increase: PropTypes.number,
  color: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
  formatter: PropTypes.func,
  increaseFormatter: PropTypes.func,
  description: PropTypes.oneOfType([commonPropTypes.i18nText, PropTypes.node])
    .isRequired,
  articleId: PropTypes.number,
  // kpiValueTestId: PropTypes.string,
  loading: PropTypes.bool,
};

DashboardKpi.defaultProps = {
  value: null,
  increase: null,
  formatter: numberFormatter,
  increaseFormatter: onePrecisionFloatFormatter,
  loading: false,
  articleId: null,
  // kpiValueTestId: null,
};
export default DashboardKpi;
